var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.875C18.6213 7.875 19.125 8.37868 19.125 9V13.5C19.125 14.1213 18.6213 14.625 18 14.625C17.3787 14.625 16.875 14.1213 16.875 13.5V9C16.875 8.37868 17.3787 7.875 18 7.875Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 7.875C30.6213 7.875 31.125 8.37868 31.125 9V13.5C31.125 14.1213 30.6213 14.625 30 14.625C29.3787 14.625 28.875 14.1213 28.875 13.5V9C28.875 8.37868 29.3787 7.875 30 7.875Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 18.555V31.695C38.25 31.935 38.235 32.175 38.22 32.4H9.78C9.765 32.175 9.75 31.935 9.75 31.695V18.555C9.75 14.52 13.02 11.25 17.055 11.25H30.945C34.98 11.25 38.25 14.52 38.25 18.555Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2203 32.4004C37.8603 36.1054 34.7403 39.0004 30.9453 39.0004H17.0553C13.2603 39.0004 10.1403 36.1054 9.78027 32.4004H38.2203Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.295 23.4306C26.97 22.9656 27.39 22.2756 27.39 21.3456C27.39 19.3956 25.83 18.3906 24 18.3906C22.17 18.3906 20.595 19.3956 20.595 21.3456C20.595 22.2756 21.03 22.9806 21.69 23.4306C20.775 23.9706 20.25 24.8406 20.25 25.8606C20.25 27.7206 21.675 28.8756 24 28.8756C26.31 28.8756 27.75 27.7206 27.75 25.8606C27.75 24.8406 27.225 23.9556 26.295 23.4306ZM24 20.2506C24.78 20.2506 25.35 20.6856 25.35 21.4356C25.35 22.1706 24.78 22.6356 24 22.6356C23.22 22.6356 22.65 22.1706 22.65 21.4356C22.65 20.6856 23.22 20.2506 24 20.2506ZM24 27.0006C23.01 27.0006 22.29 26.5056 22.29 25.6056C22.29 24.7056 23.01 24.2256 24 24.2256C24.99 24.2256 25.71 24.7206 25.71 25.6056C25.71 26.5056 24.99 27.0006 24 27.0006Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDate);
export default __webpack_public_path__ + "static/media/calendarDate.41dfbc9fbe9e928dcdf5944547cc9957.svg";
export { ForwardRef as ReactComponent };